import { IReviewSummary } from "interfaces/review.interface";
import cls from "./productSummary.module.scss";
import { useTranslation } from "react-i18next";
import Rating from "components/rating/rating";
import RangeSlider from "components/rangeSlider/rangeSlider";
import React from "react";

type Props = {
  data?: IReviewSummary;
};

export default function ProductSummary({ data }: Props) {
  const { t } = useTranslation();
  const groupValues = Object.values(
    data?.group ?? { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 },
  );
  const getPercent = (value: number) => {
    if (!value) {
      return 0;
    }
    const total = data?.count ?? 0;
    return Number(((value / total) * 100)?.toFixed(0)) || 0;
  };
  return (
    <div className={cls.container}>
      <div className={cls.header}>
        <h3 className={cls.title}>{t("customer.reviews")}</h3>
        <p className={cls.description}>
          {t("average.rating")}: {data?.avg || 0}
          <span>({data?.count || 0})</span>
        </p>
      </div>
      <div className={cls.main}>
        {groupValues?.map((value, index) => (
          <div className={cls.row} key={index}>
            <span className={cls.reviewStar}>{index + 1}</span>
            <Rating value={value} readonly count={1} />
            <div className={cls.body}>
              <RangeSlider value={getPercent(value)} />
              <div className={cls.percent}>{getPercent(value)} %</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
